import React from "react";

import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { Button } from "@material-tailwind/react";

import { ROUTES } from "../common/common.constants";

import "./notFound.scss";

const NotFound = () => {
    return (
        <Box className="fullSpace p-2">
            <Box className="fullSpace notFound flexContainer flexCol centerAlign">
                <Typography variant="h5">Page Not Found &#128531; </Typography>
                <Typography variant="subtitle1">
                    What you are looking for, is not here !
                </Typography>

                <Box className="flexContainer flexCol centerAlign p-4">
                    <Typography variant="overline" display="block">
                        Know me more, Click below !
                    </Typography>
                    <Link to={ROUTES.ABOUT_ME}>
                        <Button className="goToAboutMeBtn">
                            Go To About Me
                        </Button>
                    </Link>
                </Box>
            </Box>
        </Box>
    );
};

export default NotFound;
